import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import style from './style.module.scss'

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  className?: string
}

export const EditButton = ({ className, ...props}: Props) => {
  return (
    <button className={style.edit_btn + " " + className} type="button" title="edit" {...props}>
      <EditOutlinedIcon />
    </button>
  )
}
